<script setup>
import {computed, onUnmounted} from 'vue'
import {useRoute} from 'vue-router'
import {useOdpReportsStore} from '@/stores/odpReports'

const route = useRoute()
const odpReportsStore = useOdpReportsStore()

const formData = computed(() => odpReportsStore.formData)
const schools = computed(() => odpReportsStore.schools)

const schoolId = route.query.schoolId || ''
formData.value.schoolId = schoolId

onUnmounted(() => {
    delete formData.value.schoolId
})
</script>

<template>
    <select
        required
        v-model="formData.schoolId"
        class="form-select form-select-sm"
        name="school"
        oninvalid="this.setCustomValidity('Please select a school')"
        oninput="this.setCustomValidity('')"
    >
        <option value="">Select&hellip;</option>
        <template v-if="schools">
            <option v-for="school in schools" :key="school.id" :value="school.id">
                {{ school.name }}
            </option>
        </template>
    </select>
</template>